/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const AbsenceRateIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="-1 -1 66 60"
    onClick={props.onClick}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinecap="round" strokeWidth="2">
      <path d="M8.99466667,16.376 C11.3466667,7.15466667 19.7093333,0.333333333 29.6666667,0.333333333 C41.448,0.333333333 51,9.88266667 51,21.6666667 C51,33.4506667 41.448,43 29.6666667,43 C19.76,43 11.432,36.2506667 9.032,27.0986667" />
      <path d="M43.3573333,38.0293333 L61.6666667,56.3333333" />
      <polyline points="0.333333333 21.6666667 16.3333333 21.6666667 21.6666667 12.4453333 27 29.7786667 33.6666667 16.4453333 39 24.4453333 44.2773333 17.6666667" />
    </g>
  </svg>
);

export default AbsenceRateIcon;
